"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClassComponent = isClassComponent;
exports.isFunctionComponent = isFunctionComponent;
exports.isReactComponent = isReactComponent;

function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent;
}

function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement');
}

function isReactComponent(component) {
  return !!(isClassComponent(component) || isFunctionComponent(component));
}


//////////////////
// WEBPACK FOOTER
// ./client/components/authorisation/lib/util.js
// module id = 547
// module chunks = 0